// extracted by mini-css-extract-plugin
module.exports = {"Button":"button_Button__DQz9h","SpinnerIndicator":"button_SpinnerIndicator__pUyZI"};